var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"scroll-to-top",on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"scroll-to-top-button"},[_c('img',{staticClass:"btnimg",attrs:{"src":require("../../static/img/up.png"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"scroll-to-top-text"},[_vm._v("回到顶部")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36db0fc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollToTopButton.vue
// module id = null
// module chunks = 